"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const locale = {
  month: '{month} {month:month/months}',
  day: '{day} {day:day/days}',
  hour: '{}h',
  minute: '{}min',
  second: '{}sec',
  timedOut: 'Timed Out',
  // TODO 后面都更新后去掉
  moreThanOneMonth: 'More than one month'
};
var _default = exports.default = locale;